import { render } from "./ModalEditarEstado.vue?vue&type=template&id=f003273a"
import script from "./ModalEditarEstado.vue?vue&type=script&lang=js"
export * from "./ModalEditarEstado.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__